const routes = {
  HOME: "/",
  LOGIN: "/login",
  PROFILE: "/profile",
  RESET_PASSWORD: "/login/reset",
  CLASSES: {
    HOME: "/classes",
    UPCOMING: "/classes/upcoming",
    PREVIOUS: "/classes/previous",
    SUBMISSIONS: "/classes/submissions",
    ASSIGNMENTS: "/classes/submissions/assignments",
    ASSIGNMENTQUESTIONS: "/classes/submissions/assignments/:id",
    EXAMS: "/classes/submissions/exams",
    EXAMQUESTIONS: "/classes/submissions/exams/:id",
  },
  ACADEMIC: {
    HOME: "/academic",
    PROGRAMS: "/academic/programs",
    PROGRAM: "/academic/programs/:id",
    NEW_SCHEDULE: "/academic/programs/:id/create-schedule",
    COURSES: "/academic/courses",
    COURSE: "/academic/courses/:id",
  },
  ACCOUNTING: {
    HOME: "/accounting",
    MYEXPENSES: "/accounting/expenses",
    CASHREGISTER: "/accounting/register",
    REGISTERAPPROVALS: "/accounting/register/approvals",
    ACCOUNTS: "/accounting/accounts",
    ACCOUNTTRANSFERS: "/accounting/accounts/:id",
    FEES: "/accounting/fees",
    PROGRAMFEE: "/accounting/fees/:programId",
    FEEAPPROVALS: "/accounting/fees/approvals",
  },
  ADMIN: {
    HOME: "/admin",
    SESSION: "/admin/session",
    ADMISSION: "/admin/admission",
    INSTITUTE: "/admin/institute",
    STUDENTS: "/admin/students",
    STUDENT: "/admin/students/:id",
    FACULTIES: "/admin/faculties",
    FACULTY: "/admin/faculties/:id",
    STAFFS: "/admin/staffs",
    STAFF: "/admin/staffs/:id",
  },
  ASSETS: {
    HOME: "/assets",
    ASSETS: "/assets/assets",
    INVENTORIES: "/assets/inventories",
  },
  DAILY_SCHEDULE: "/daily-schedule",
  ACTIVITY: "/activity",
  CALENDAR: "/calendar",
  NEW_SCHEDULE: "/create-schedule",
}

export default routes
